import { render, staticRenderFns } from "./ResidentHistoryTab.vue?vue&type=template&id=79445620&scoped=true&"
import script from "./ResidentHistoryTab.vue?vue&type=script&lang=ts&"
export * from "./ResidentHistoryTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79445620",
  null
  
)

export default component.exports